export default "__VITE_ASSET__ec9b4e6c__"